import yjapis  from "../../api/yj";
import fddapis  from "../../api/fdd";
import applyapis  from "../../api/apply";

export default {
    name: "OutApply",

    data() {
        return {
            userId:"",
            personName:'',
            personCode:'',
            personCompanyText:'',
            money:'',
            loanId:'',
            loanItem:{},
            area:'',
            yjBankList:[],
            bankList:[],
            bank:'',
            firstBusiness:'',
            secondBusiness:[],
            BusinessDetail:'',
            businessShow:false,
            peopleCount:'',
            lastYearIncome:'',
            lastYearTax:'',
            lastYearProfit:'',
            phone:'',
            chooseType:'2',
            company:'',
            companyCode:'',
            loanList:[],
            dialogVisible:false,
            companyList:[],
            pageIndex:1,
            pageSize:20,
            companyTotalCount:0,
            addVisible:false,
            flowId:'',
        }
    },
    created() {
        this.getLoanList()
        this.getYjBankList()
    },
    activated() {
      // let that = this
      
    },
    mounted() {
      let that = this;
      that.calcTableHeight();
      // 注：window.onresize只能在项目内触发1次
      window.onresize = function windowResize () {
        that.calcTableHeight();
      }
    },
    methods: {
      calcTableHeight(){
        this.$nextTick(() => {
          var height1=$(".content-box .content").height();
          var height=height1-50-20-40;
          this.scrollHeight = height;
        });
      },
        getYjBankList(){
            var that=this;
            yjapis.getBankList({state:2}).then(res => {
                        that.yjBankList=res.list;
                        if(that.yjBankList.length==1)that.bank=that.yjBankList[0].BankID;
            });
        },
        getLoanList(){
            fddapis.getYjConfig({}).then(res => {
                this.loanList=[];
                this.loanList.push(res)
                this.loanId=res.Id;
                this.loanItem=res;
            });
        },
        openCompanyDialog(){
            if(this.personName===''){
                this.$message.error("请输入申请者姓名");
                return;
            }
            this.dialogVisible = true
            this.pageIndex = 1
            this.companyTotalCount = 0
            this.companyList = []
            this.getCompanyList()
        },
        getCompanyList(){
            let _this = this
            applyapis.getCompanyPage({page:_this.pageIndex,name:_this.personName}).then(res=>{
                if(res.Paging==null){
                    _this.companyList = []
                }else{
                    _this.companyList = res.Result
                    _this.companyTotalCount = Number(res.Paging.TotalRecords)
                }
            })
        },
        // 分页导航
        handlePageChange(val) {
            this.pageIndex = val;
            this.getCompanyList()
        },

        chooseCompany(row){
          this.company = row.Name
          this.companyCode = row.CreditCode
          this.dialogVisible = false
        },
        verifyIdCard (val) {
            return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(val) // 返回true或false
        },
        verifyPhone (val) {
            return /^1\d{10}$/.test(val) // 返回true或false
        },
        verifyNumber(val){
          return /(^[1-9]\d*$)/.test(val)
        },
        onSubmit(){
            let applyObj = {}
            let _this = this
            if(this.chooseType==='2'){
                 applyObj.personCompany={
                                flag:'2',
                               username:this.personName,
                               idCard:this.personCode,
                                companycode:this.companyCode,
                                companyname:this.company,
                 };
            }else{
                   applyObj.personCompany = {
                        flag:'1',
                        username:this.personName,
                        idCard:this.personCode
                    }
            }
            applyObj.phone = this.phone
            applyObj.personName =this.personName
            applyObj.personCode = this.personCode
            applyObj.money = this.money
            applyObj.loanId =this.loanId
            applyObj.BankID = this.bank
            applyObj.UserId=this.userId?this.userId:0;
            let check = this.checkApplyInfo(applyObj)
            if(check.flag){
                yjapis.addYJLoanApply(applyObj).then(res=>{
                  if(res==1){
                    _this.addVisible=false;
                    _this.$message({
                        message: '申请成功',
                        type: 'success',
                        onClose:function(){
                            //关闭这个tag，且跳转到流程管理列表
                            //如果流程管理tag存在，跳转过去之后还要刷新
                            //如果流程管理tag不存在，直接打开应该就可以
                          _this.$router.push("/YjApply/index")
                            _this.emptyData()
                        }
                    });
                }else if(res==2){
                   _this.$message({
                        message:"用户编号有误",
                        type: 'error',
                    })
                }else if(res==3){
                   _this.$message({
                        message:"贷款类型已失效",
                        type: 'error',
                    })
                }
                })
            }else{
                this.$message.error(check.msg);
            }
        },
        onSubmit2(){
            this.addVisible=true;
        },
        addLoanApply2(){
            let _this = this
            var flowId=this.flowId;
            if(flowId=="")this.$message.error("请输入流程编号");
            else 
            yjapis.addYJLoanApply2({Id:flowId}).then(res=>{
                if(res){
                    _this.addVisible=false;
                    _this.$message({
                        message: '申请成功',
                        type: 'success',
                        onClose:function(){
                            //关闭这个tag，且跳转到流程管理列表
                            //如果流程管理tag存在，跳转过去之后还要刷新
                            //如果流程管理tag不存在，直接打开应该就可以
                            _this.$router.push("/YjApply/index")
                            _this.emptyData()
                        }
                    });
                }else {
                   _this.$message({
                        message:"提交失败",
                        type: 'error',
                    })
                }
            })
        },
        emptyData(){
                this.userId = ''
                this.personName = ''
                this.personCode = ''
                this.personCompanyText = ''
                this.money = ''
                this.phone = ''
                this.chooseType = '2'
                this.company = ''
                this.companyCode = ''
                this.pageIndex = 1
                this.pageSize = 20
                this.companyTotalCount = 0
        },
        getLoanItem(){
          for(let i=0;i<this.loanList.length;i++){
              if(this.loanList[i].LoanName===this.loanName){
                  return this.loanList[i]
              }
          }
        },
        getAreaItem(){
          for(let i=0;i<this.yjBankList.length;i++){
              if(this.yjBankList[i].AreaCode === this.area){
                  return this.yjBankList[i]
              }
          }
        },
        checkApplyInfo(info){
            if(info.personName===""){
                return {flag:false,msg:"请您输入申请人姓名"}
            }
            if(info.personCode===""){
                return {flag:false,msg:'请你输入申请人身份证号码'}
            }
            this.company = this.company.replace(/\s/g, "");
            if(this.chooseType==='2'&&this.company===""){
                return {flag:false,msg:'您必须选择一个企业或者输入名称'}
            }
            if(info.loanId === ""){
                return {flag:false,msg:"请您选择贷款类型"}
            }
            if(!info.money){
                return {flag:false,msg:"请输入贷款金额"}
            }
            // else{
            //     let loanItem = this.loanItem
            //     if(Number(info.money)>Number(loanItem.MaxMoney)){
            //         return {flag:false,msg:'贷款金额须不超过'+loanItem.MinMoney+"(万元)"}
            //     }
            // }
            if(info.BankID === ""){
                return {flag:false,msg:'请您选择银行'}
            }
            if(info.phone === ""){
                return {flag:false,msg:"请输入联系方式"}
            }
            if(!this.verifyPhone(info.phone)){
                return {flag:false,msg:'请您输入正确的联系方式'}
            }
            if(!this.verifyIdCard(info.personCode)){
                return {flag:false,msg:'请您输入正确的身份证号'}
            }
            return {flag:true}
        },
        onFirstBusinessChooseConfirm(value){
            this.firstBusiness = value
            //变更二级分类的标题和placeholder
            this.changeSecondBusinessShow(value)
        },
        changeSecond(){
         var value=this.secondBusiness;
         for(var i=0;i<value.length;i++){
            if(value[i]=="其他"){
                this.businessShow=true;
                return
          }
          }
          this.businessShow=false;
        },
        changeSecondBusinessShow(value){
            switch (value) {
                case '电商':
                    this.secondBusinessTitle = '销售类目'
                    this.secondBusinessPlaceHolder = '如：生鲜、粮油'
                    break;
                case '种植':
                    this.secondBusinessTitle = '种植作物'
                    this.secondBusinessPlaceHolder = '如：水稻、棉花'
                    break;
                case '养殖':
                    this.secondBusinessTitle = '养殖种类'
                    this.secondBusinessPlaceHolder = '如：猪、肉牛'
                    break;
                case '农产品加工':
                    this.secondBusinessTitle = '加工品类'
                    this.secondBusinessPlaceHolder = '如：粮食加工、柑橘加工'
                    break;
                case '农资农机销售':
                    this.secondBusinessTitle = '销售品类'
                    this.secondBusinessPlaceHolder = '如：播种机、拖拉机、农资销售'
                    break;
                case '农产品购销':
                    this.secondBusinessTitle = '产品类型'
                    this.secondBusinessPlaceHolder = '如：柑橘、蔬菜'
                    break;
                case '农业服务':
                    this.secondBusinessTitle = '服务项目'
                    this.secondBusinessPlaceHolder = '如：收割、无人机植保'
                    break;
                case '农业旅游农家乐':
                    this.secondBusinessTitle = '产业类型'
                    this.secondBusinessPlaceHolder = '如：玫瑰园、果园、农家乐餐饮'
                    break;
                case '农业相关工程':
                    this.secondBusinessTitle = '工程内容'
                    this.secondBusinessPlaceHolder = '如：大棚、土壤改良、绿化工程'
                    break;
                case '其他':
                    this.secondBusinessTitle = '经营项目'
                    this.secondBusinessPlaceHolder = '请填经营项目'
                    break;
            }
        },

    },
  };
